import ItemIniter from "../../items/ItemIniter.js";
import ItemProviders from "../../items/ItemProviders.js";

export default class ToolPanel {
	constructor(cell, mc, row, col, data, lNew, callback = null, showOnly = false) {
		this.cell = cell;
		this.mc = mc;
		this.row = row;
		this.col = col;
		this.lNew = lNew;
		this.initer = data;
		this.callback = callback;
		this.showOnly = showOnly;
	}

	init() {
		//jQuery(".js-rowcol", this.mc).text("Row:" + this.row + " Col:" + this.col);
		let initer = this.initer;

		for (let prop in initer) {
			if (this.canShow(initer, prop)) {

				let type = initer[prop].constructor.name;
				if (type === "String") {
					let a = Object.getOwnPropertyNames(ItemProviders);
					let cmp = prop.toUpperCase() + "_"
					let lSelect = false;
					for (let x = 0; x < a.length; x++) {
						//console.log(a[x],cmp)
						if (a[x].indexOf(cmp) === 0) {
							lSelect = true;
							this.addSelect(initer, prop);
							break;
						}
					}
					if (!lSelect) {
						this.addTextfield(initer, prop);
					}
				}
				if (type === "Number") {
					this.addTextfield(initer, prop);
				}
				if (type === "Boolean") {
					this.addCheckbox(initer, prop);
				}
				//console.log(initer[prop].constructor.name)

			}
		}
		//console.log(Object.getOwnPropertyNames(ItemProviders))

		jQuery(".js-save", this.mc).on("click", this.onSave.bind(this));
		jQuery(".js-copy", this.mc).on("click", this.onCopy.bind(this));
		if (this.lNew) {
			jQuery(".js-delete", this.mc).css({ "opacity": 0.5, "pointer-events": "none" });
		} else {
			jQuery(".js-delete", this.mc).on("click", this.onDelete.bind(this));
			
		}

		if (!ToolPanel.COPIED) {
			jQuery(".js-paste", this.mc).css({ "opacity": 0.5, "pointer-events": "none" });
		} else {
			jQuery(".js-paste", this.mc).on("click", this.onPaste.bind(this));
			
		}

	}

	onCopy() {
		let exclude = ["row", "col", "rownew", "colnew", "id", "sheet", "startItem", "worn", "containerPos", "bound"];
		let o = new Object();
		for (let prop in this.initer) {
			if (exclude.indexOf(prop) === -1) {
				o[prop] = this.initer[prop];
			}
		}
		//this.dispatch({ type: ToolPanel.EVENT_COPY, data: { item: this.initer, copy: o } });
		ToolPanel.COPIED = o;
		console.log(o)
	}

	onPaste() {
		let o = ToolPanel.COPIED;
		for (let prop in o) {
			this.initer[prop] = o[prop];
		}
		//console.log(this.initer);
		this.dispatch({ type: ToolPanel.EVENT_CHANGED, data: { item: this.initer, data: this } });

	}

	onSave() {
		this.update();

		this.dispatch({ type: ToolPanel.EVENT_CHANGED, data: { item: this.initer, data: this } });
	}

	onDelete() {
		this.dispatch({ type: ToolPanel.EVENT_DELETE, data: { item: this.initer, data: this } });
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}


	canShow(initer, prop) {
		let type = initer.type;
		let a = ItemProviders.SHOWN;
		for (let x = 0; x < a.length; x++) {
			let o = a[x];
			if (o.types.indexOf(type) >= 0) {
				if (o.props.indexOf(prop) >= 0) {
					return true;
				}

			}
		}
		return false;
	}


	addSelect(initer, prop) {
		let el = jQuery("#template-i-select").clone();
		el.attr("id", "el" + ToolPanel.ENUM++)
		jQuery(".js-entries", this.mc).append(el);
		jQuery(".js-label", el).text(prop);
		jQuery(".js-element", el).addClass("el-" + prop);

		let cmp = prop.toUpperCase() + "_"
		let a = Object.getOwnPropertyNames(ItemProviders);
		for (let x = 0; x < a.length; x++) {
			if (a[x].indexOf(cmp) === 0) {
				let opt = jQuery("<option></option>");
				opt.attr("value", ItemProviders[a[x]])
				opt.text(ItemProviders[a[x]]);
				jQuery(".js-element", el).append(opt);
			}
		}
		jQuery(".js-element", el).val(initer[prop]);
	}



	addTextfield(initer, prop) {
		let el = jQuery("#template-i-text").clone();
		el.attr("id", "el" + ToolPanel.ENUM++)
		jQuery(".js-entries", this.mc).append(el);
		jQuery(".js-label", el).text(prop);
		jQuery(".js-element", el).val(initer[prop]);
		jQuery(".js-element", el).addClass("el-" + prop);
	}
	addCheckbox(initer, prop) {
		let el = jQuery("#template-i-check").clone();
		el.attr("id", "el" + ToolPanel.ENUM++)
		jQuery(".js-entries", this.mc).append(el);
		jQuery(".js-label", el).text(prop);
		if ("" + initer[prop] === "true") {
			jQuery(".js-element", el).attr("checked", true);
		}
		jQuery(".js-element", el).addClass("el-" + prop);

	}


	update() {
		for (let prop in this.initer) {
			if (this.canShow(this.initer, prop)) {
				let type = this.initer[prop].constructor.name;
				if (type === "String") {
					this.initer[prop] = jQuery(".el-" + prop, this.mc).val();
				}
				if (type === "Number") {
					this.initer[prop] = parseInt(jQuery(".el-" + prop, this.mc).val());
				}
				if (type === "Boolean") {
					let checked = jQuery(".el-" + prop, this.mc).is(":checked");
					this.initer[prop] = checked ? true : false
				}
			}
		}
	}

}

ToolPanel.ENUM = 0;
ToolPanel.EVENT_CHANGED = "eventChanged";
ToolPanel.EVENT_DELETE = "eventDelete";


